export default __webpack_public_path__ + "static/media/playStore.808a2960.png";